module.exports = __webpack_public_path__ + "media/src/images/logo-light-bg@2x-b4d7849a73ec7ddaf54e44575a954fbe.png";